var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecklist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.83333 12.5L0 9.66666L1.0625 8.60416L2.8125 10.375L6.35417 6.83333L7.4375 7.89583L2.83333 12.5ZM2.83333 6L0 3.16666L1.0625 2.10416L2.83333 3.87499L6.35417 0.333328L7.4375 1.39583L2.83333 6ZM9 11V9.5H16V11H9ZM9 4.5V2.99999H16V4.5H9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklist);
export default __webpack_public_path__ + "static/media/checklist.e1184b2a1a63e1577e022b94d46c93f8.svg";
export { ForwardRef as ReactComponent };